import React from 'react';
import { LoaderContainer, LoaderImage, LoaderContent, LoaderText } from './styles';
import loading from '../../assets/images/KOALoader.gif';

const Loader = () => {

  return (
    <LoaderContainer id="loaderDebt">
      <LoaderContent>
        <LoaderImage src={loading} alt="Loading Excel Credit" />
        <LoaderText>
          Es necesario mantener este proceso activo. No cierres esta ventana, espera que estamos validando la información.
        </LoaderText>
      </LoaderContent>
    </LoaderContainer>
  )
}

export default Loader;
